import 'Tools/xray';
import { initDWHLogger } from 'Tools/dwhLogger';
void initDWHLogger();
